import { Content } from "@/components/Navigation/Buttons/StoreFinderButton/components/content/content";
import { useStoreFinderButtonContext } from "@/components/Navigation/Buttons/StoreFinderButton/context/storeFinderButton.context";
import { Base } from "@/components/Navigation/Buttons/StoreFinderButton/storeFinderButton.base";

export const StoreFinderButton = Object.assign(Base, {
    useContext: useStoreFinderButtonContext,
    Content: Content
});
